// Theme Presets

const lightTheme = {
  name: "light",
  body: "#F4F7FB", // Cool off-white page background
  text: "#0A192F", // Navy ink for body copy
  dark: "#000000", // Kept for darkest elements like text or icons
  secondaryText: "#5A6B85", // Slate for subtitles and metadata
  accentColor: "#0E7C86", // Deep teal accent
  accentBright: "#0B6B74", // Deeper teal for solid buttons
  accentText: "#FFFFFF", // Text/icon color that sits on top of the accent
  border: "#D7E0EC", // Hairline borders and dividers
  shadow: "rgba(10, 25, 47, 0.10)", // Resting card shadow
  shadowStrong: "rgba(10, 25, 47, 0.18)", // Hover / raised shadow
  projectCard: "#FFFFFF", // Card surface on the light background
  skinColor: "#F7B799", // Unchanged as it is a skin color
  skinColor2: "#FCB696", // Unchanged as it is a skin color
  imageDark: "#dce4f2", // Unchanged, assuming it's for shadows or dark areas in images
  imageClothes: "#dce4f2", // A slightly different blue to add more variety
  avatarMisc: "#e9ecf2", // Light grey-blue for misc avatar items
  avatarShoes: "#ccd2e3", // Greyish blue for shoes to add depth
};

const darkTheme = {
  name: "dark",
  body: "#0A192F", // Deep navy as the primary background color
  text: "#E6F1FF", // Soft white for text for readability against dark blue
  dark: "#000000", // Kept for elements that require full black
  secondaryText: "#8892B0", // Slate blue for subtitles and metadata
  accentColor: "#64FFDA", // Cyan accent that pops against the navy
  accentBright: "#4FD1C5", // Deeper cyan-teal for solid buttons
  accentText: "#0A192F", // Text/icon color that sits on top of the accent
  border: "#1E3A5F", // Hairline borders and dividers
  shadow: "rgba(2, 12, 27, 0.55)", // Resting card shadow
  shadowStrong: "rgba(2, 12, 27, 0.75)", // Hover / raised shadow
  projectCard: "#112240", // Raised navy for card backgrounds
  skinColor: "#B28B67", // A darker skin color for better contrast against dark theme
  skinColor2: "#C99A76", // Another skin color option with good contrast
  imageDark: "#112240", // Dark blue for dark areas of images to blend with the theme
  imageClothes: "#233554", // A different dark blue for clothing to create depth
  avatarMisc: "#14253D", // Slightly lighter dark blue for miscellaneous items
  avatarShoes: "#2B3A67", // A blue that stands out slightly for shoes
};

export const themes = { light: lightTheme, dark: darkTheme };
